/**
 * Which step owns each field the server can name in a validation response.
 *
 * The submission happens on the last step, but `consultationTypeId` belongs to step 1 and
 * `preferredDate` to step 3 — so without this the wizard would mark a control nobody can see and
 * show the customer nothing at all, which is worse than the banner it replaced. The wizard returns
 * to the step that owns the first offending field.
 *
 * `city` belongs to step 1, beside the format, because it narrows the consultants step 2 offers.
 *
 * `requestedMemberId` is the one field here the server can refuse for a reason that has nothing to
 * do with what the customer typed — a card switched off while the wizard was open — so the step it
 * returns to is the step that offers the alternatives, including skipping.
 *
 * The keys are the server's property names as `describeFieldErrors` lower-cases them.
 */
export const FIELD_STEP: Record<string, number> = {
    consultationTypeId: 1,
    meetingFormat: 1,
    city: 1,
    requestedMemberId: 2,
    preferredDate: 3,
    preferredTime: 3,
    customerName: 4,
    customerLastName: 4,
    customerPhone: 4,
    customerEmail: 4,
    preferredLanguage: 4,
    consentVersion: 4
};
